export enum ComponentEnum {
  TotalLandProperty = 'totalLandProperty',
  AverageLandArea = 'averageLandArea',
  LandDevelopmentRate = 'landDevelopmentRate',
  ResidentialLandSupply5Years = 'residentialLandSupply5Years',
  IndependentProperties = 'independentProperties',
  GovernmentalProperties = 'governmentalProperties',
  HouseVillaProjects = 'houseVillaProjects'
}
